.ag{flex-shrink:0;}